<div class="col-content show-display">
  <div class="header-content mb-xl-5 mb-3">
    <div class="heading">Instalaciones de gestión</div>
    <!-- <div class="heading">{{adheridoInfo?.razonSocial}}</div> -->
    <div class="actions">
      <button *ngIf="canAccessGestoresAcuerdo()" type="button" class="btn btn-primary"
        (click)="openModalManagers()" data-toggle="modal">Nuevo gestor</button>
      <!--TODO mat drop down menu
      <div class="dropdown show" *ngIf="canAccessExportarCentro()">
        <a class="btn btn-outline-primary" href="#" role="button"
          aria-haspopup="true" aria-expanded="false"><span>Exportar</span></a>
      </div> -->
    </div>
  </div>
  <div *ngIf="gridArray?.length !== 0 else messageClear"
    class="datatable-container table-responsive overflow-table table-detail-width-100">
    <lib-ge-table [headArray]="headArray" [gridArray]="gridArray" (actionButton)="action($event)"></lib-ge-table>
    <div class="d-flex pb-2 flex-row justify-content-center align-items-center">
      <div class="d-flex mt-2" *ngIf="hasMultiplePages()">
        <ngb-pagination [pageSize]="pageSize" [collectionSize]="recordsTotal" [(page)]="pageNumber"
          (pageChange)="renderPage($event)" [maxSize]="5" aria-label="Default pagination" size="sm">
        </ngb-pagination>
      </div>
      <div class="mt-2 selectPage" *ngIf="hasMultiplePages()">
        <label for="itemsPerPage">Mostrar:</label>
        <select id="itemsPerPage" [(ngModel)]="selectedItemsPerPage" (change)="onItemsPerPageChange()">
          <option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
        </select>
      </div>
    </div>
  </div>
  <ng-template #messageClear>
    <div class="container-menu">
      <div class="mensaje-container">
        <p class="mensaje-linea">Sin información registrada</p>
      </div>
    </div>
  </ng-template>
</div>
